module.exports = __webpack_public_path__ + "img/Coloca_Pega Total Blanco.ddd8a79c.png";